<script>
    import LyHeader from '../components/LyHeader.svelte';
    import LyForm from '../forms/LyForm.svelte';
    import LyButtons from '../forms/LyButtons.svelte';
    import LyButton from '../forms/LyButton.svelte';
    import { ApiService } from '../../services/ApiService.js';
    import LyFieldset from '../forms/LyFieldset.svelte';
    import LyInputEMail from '../forms/LyInputEMail.svelte';
    import { MessageStore } from '../../stores/MessageStore.svelte.js';
    import LyHeadline from '../components/LyHeadline.svelte';

    /**
     * @type {{
     *      email?: string,
     *      openLogin?: () => void,
     *      openResetPassword?: (email: string) => void
     * }}
     */
    let { email = '', openLogin = () => {}, openResetPassword = () => {} } = $props();
    let disableForm = $state(false);
    const api = new ApiService();

    async function tryRegister() {
        disableForm = true;

        // -
        email = email.trim().toLocaleLowerCase();

        // -
        if (email === '') {
            MessageStore.error('Bitte die E-Mail-Adresse eingeben.');
            disableForm = false;
            return;
        }

        // -
        if (!email.endsWith('@dwc.gmbh')) {
            MessageStore.error('Die E-Mail-Adresse muss mit "@dwc.gmbh" enden.');
            disableForm = false;
            return;
        }

        // -
        const canRegister = await api.callUserRegisterEmailIsValid(email);
        if (canRegister.ok && canRegister.data.value) {
            const success = await api.callUserRegisterByEmail(email);
            if (success.ok && success.data.value) {
                openResetPassword(email);
            } else {
                disableForm = false;
            }
        } else {
            disableForm = false;
        }
    }
</script>

<LyHeader>
    <LyHeadline>Neues Konto anlegen</LyHeadline>
</LyHeader>
<LyForm mt="4" tag="div">
    <LyFieldset border={false}>
        <LyInputEMail
            name="email"
            required={true}
            autofocus={true}
            label="E-Mail-Adresse"
            placeholder="x.y@dwc.gmbh"
            autocomplete="email"
            bind:value={email}
            onkeydown={(e) => e.key === 'Enter' && tryRegister()} />
    </LyFieldset>
    <LyButtons>
        <LyButton label="Registrieren" disabled={disableForm} onclick={tryRegister} />
    </LyButtons>
    <LyButtons mt={true}>
        <LyButton label="Zurück" color={true} onclick={openLogin} />
    </LyButtons>
</LyForm>
